import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  FileProgrammingGraphqlApi,
  SalesClientFilterOption,
  SalesClientFilterOptionsInput
} from './file-programming.graphql-api';
import { FilesViewMode } from '../model/programming-file';

export interface ProgrammingFilesFiltersQuery {
  year?: string | null;
  status?: string | null;
  search?: string | null;
  nameClient?: string | null;
  startDateFileFrom?: string | null;
  startDateFileTo?: string | null;
}

export interface ProgrammingFilesSortQuery {
  field: 'updatedAt' | 'startDateFile';
  direction: 'asc' | 'desc';
}

export interface ProgrammingFilesQuery {
  view: FilesViewMode;
  limit: number;
  cursor?: string | null;
  filters?: ProgrammingFilesFiltersQuery;
  sort?: ProgrammingFilesSortQuery;
}

@Injectable({ providedIn: 'root' })
export class FileProgrammingRepository {
  constructor(
    private readonly fileProgrammingApi: FileProgrammingGraphqlApi
  ) {}

  getProgrammingFilesPage(input: ProgrammingFilesQuery): Observable<any> {
    return this.fileProgrammingApi.getProgrammingFilesPage(input);
  }

  getSalesPassengersByItinerary(idItinerary: string): Observable<any> {
    return this.fileProgrammingApi.getSalesPassengersByItinerary(idItinerary);
  }

  getSalesClientFilterOptions(
    input: SalesClientFilterOptionsInput
  ): Observable<{ getSalesClientFilterOptions: SalesClientFilterOption[] }> {
    return this.fileProgrammingApi.getSalesClientFilterOptions(input);
  }
}
